import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import type { MainLayoutContextType } from './MainLayoutContext';
import MainLayoutContext from './MainLayoutContext';

const MainLayoutProvider = ({ children }: PropsWithChildren) => {
  const [title, setTitle] = useState<MainLayoutContextType['title']>('');

  const value: MainLayoutContextType = {
    title,
    setTitle,
  };

  return (
    <MainLayoutContext.Provider value={value}>
      {children}
    </MainLayoutContext.Provider>
  );
};

export default MainLayoutProvider;
